module.exports = __webpack_public_path__ + "static/quote-icon-c0db7eb24cddd14bc4da5a5e39a2360a.png";